export * from './translate-static-loader.service';


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/multi-language/browser/index.ts